import { HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { PageResult } from "@models/requests/page-result.interface";
import { TextMessageModel } from "@models/text-messages-templates/text-message-model";
import { TextMessageRecord } from "@models/text-messages-templates/text-message-record";
import { TextMessageSendRequest } from "@models/text-messages-templates/text-message-send-request";
import { TextMessageTemplate } from "@models/text-messages-templates/text-message-template";
import { TextMessagesTemplateSettingsBase } from "@models/text-messages-templates/text-messages-template-settings-base";
import BaseApiService from "@shared/services/base/base-api.service";
import { IServerSideGetRowsRequest } from "ag-grid-enterprise";
import { map, Observable } from "rxjs";

@Injectable()
export class TextMessageApiService extends BaseApiService {
  loadTextMessageTemplates(): Observable<TextMessageTemplate[]> {
    return this.api.get<TextMessageTemplate[]>(`${ this.apiUrl }/textmessages/templates`);
  }

  loadSmsDefaultTemplates(): Observable<Record<string, TextMessagesTemplateSettingsBase>> {
    return this.api.get<Record<string, TextMessagesTemplateSettingsBase>>(`${ this.apiUrl }/textmessages/templates/default`);
  }

  saveTextMessageTemplate(textMessageTemplate: TextMessageTemplate): Observable<TextMessageTemplate> {
    return this.api.post<TextMessageTemplate>(`${ this.apiUrl }/textmessages/templates`, textMessageTemplate);
  }

  sendTestTextMessageTemplate(sendRequest: TextMessageSendRequest): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/textmessages/send`, sendRequest);
  }

  getOutgoingTextMessagesList(request: IServerSideGetRowsRequest, search?: string): Observable<PageResult<TextMessageRecord>> {
    let params = new HttpParams();
    if (search) {
      params = params.append('search', search);
    }

    return this.api.post<PageResult<TextMessageRecord>>(`${ this.apiUrl }/textmessages/grid`, request, { params })
      .pipe(
        map((response => {
          response.records = response.records.map((textMessageRecord) => new TextMessageRecord(textMessageRecord));
          return response;
        }))
      );
  }

  getOutgoingTextMessageDetails(textMessageId: string): Observable<TextMessageModel> {
    return this.api.get<TextMessageModel>(`${ this.apiUrl }/textmessages/${ textMessageId }/details`)
      .pipe(
        map((textMessageModel) => new TextMessageModel(textMessageModel))
      );
  }

  resendOutgoingTextMessage(textMessageId: string): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/textmessages/${ textMessageId }/resend`);
  }

  deleteOutgoingTextMessage(textMessageId: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/textmessages/${ textMessageId }`);
  }
}

